import { render, staticRenderFns } from "./onboarding-modal.vue?vue&type=template&id=cc5390b4"
import script from "./onboarding-modal.vue?vue&type=script&lang=js"
export * from "./onboarding-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports